import React, { useEffect, useState } from "react";

import { Compact } from "./Compact";
import { Expanded } from "./Expanded";

import * as styles from "./styles.module.scss";

export const Interface = ({
    loading,
    guide,
    language,
    version,
    open,
    expanded,
    setLanguage,
    setVersion,
    setOpen,
    setExpanded,
}) => {
    const [current, setCurrent] = useState(window.audioplayer._index);



    const handleClose = () => {
        setOpen(false);
        window.audioplayer.reset();
    };

    useEffect(() => {
        const audioguideSelectListener = (event) => {
            if (typeof event.index !== "undefined") {
                setCurrent(event.index);
            }
        };

        const audioguideResetListener = () => {
            setCurrent(-1);
        };

        window.audioplayer.addEventListener("select", audioguideSelectListener);
        window.audioplayer.addEventListener("reset", audioguideResetListener);

        return () => {
            window.audioplayer.removeEventListener("select", audioguideSelectListener);
            window.audioplayer.removeEventListener("reset", audioguideResetListener);
        };
    }, []);

    if (!open || loading || !guide || !version) {
        return null;
    }

    const currentTrack = version.tracks[current];

    return (
        <div className={styles.interface}>
            {expanded ? (
                <Expanded
                    guide={guide}
                    language={language}
                    version={version}
                    track={currentTrack}
                    setLanguage={setLanguage}
                    setVersion={setVersion}
                    onToggle={() => setExpanded(false)}
                />
            ) : (
                <Compact
                    guide={guide}
                    language={language}
                    version={version}
                    track={currentTrack}
                    onToggle={() => setExpanded(true)}
                    onClose={handleClose}
                />
            )}
        </div>
    );
};
